import modules from './modules'
import getters from './getters'

const store = new Vuex.Store({
    modules: modules,
    getters
})
// //刷新加载的方法
// const refresh=function(){
//     //页面刷新重新加载路由
//     store.dispatch('add_Routes_Fresh');
// }
// refresh();
export default store



// WEBPACK FOOTER //
// ./src/store/index.js